<div class="formly-field-wrap">
  <div class="client-select-shell" [class.is-disabled]="isInteractionDisabled">
    @if (showMissingItemsWarning) {
      <div class="warning-banner">
        {{ 'CLIENT_SELECT.WARNING.MISSING_ITEMS' | translate }}
      </div>
    }

    @if (isHydrating) {
      <div class="loading-banner">
        <span class="inline-spinner" aria-hidden="true"></span>
      </div>
    }

    @if (selectedRecords.length > 0) {
      <div class="selected-items-panel">
        <div class="selected-items-scroll-shell">
          <table class="selected-items-table">
            <thead>
              <tr class="selected-items-header">
                @for (column of selectedColumns; track column) {
                  <th scope="col">{{ getColumnLabel(column) }}</th>
                }
                @if (!isInteractionDisabled) {
                  <th scope="col" class="selected-items-header__action sr-only">Actions</th>
                }
              </tr>
            </thead>
            <tbody>
              @for (row of selectedDisplayRows; track row.id) {
                <tr class="selected-item-row">
                  @for (cell of row.cells; track $index) {
                    <td>
                      <div class="summary-field">
                        <span class="summary-value">{{ cell }}</span>
                      </div>
                    </td>
                  }

                  @if (!isInteractionDisabled) {
                    <td class="selected-item-action-cell">
                      <button type="button" class="icon-action selected-item-action" (click)="removeSelectedRecord($index)" aria-label="Remove selected item">
                        <i class="fa-solid fa-circle-xmark" aria-hidden="true"></i>
                      </button>
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    } @else {
      <!-- <div [class]="(options.formState.showCompactViewWhenDisabled ? 'compact-' : '') + 'disabled-text empty-state'">
        <span>{{ placeholderText }}</span>
      </div> -->
    }

    @if (canAddItem) {
      <div class="actions-row">
        <button type="button" class="actions-row-button" (click)="openPicker()"> {{ 'CLIENT_SELECT.ACTION.ADD_ITEM' | translate }}</button>
      </div>
    }

    @if (isPickerOpen) {
      <div class="picker-overlay" (click)="closePicker()">
        <div class="picker-dialog" role="dialog" aria-modal="true" [attr.aria-label]="field.props.label" (click)="$event.stopPropagation()">
          <div class="picker-header">
            <h3 class="picker-title">{{ field.props.label }}</h3>
            <button type="button" class="picker-close-button" (click)="closePicker()">
              {{ 'CLIENT_SELECT.ACTION.CLOSE' | translate }}
            </button>
          </div>

          <div class="modal-content">
            <div class="search-shell">
              <label class="sr-only" for="client-select-search-input">{{ 'CLIENT_SELECT.PLACEHOLDER.SEARCH' | translate }}</label>
              <input
                id="client-select-search-input"
                class="search-input"
                type="search"
                [ngModel]="searchText"
                [title]="'CLIENT_SELECT.PLACEHOLDER.SEARCH' | translate"
                [placeholder]="'CLIENT_SELECT.PLACEHOLDER.SEARCH' | translate"
                (input)="onSearchInput($event)"
              />
            </div>

            @if (loadError) {
              <div class="status-card error-state">
                <span>{{ loadError | translate }}</span>
                <button type="button" class="secondary-button" (click)="retryLoad()">{{ 'CLIENT_SELECT.ACTION.RETRY' | translate }}</button>
              </div>
            } @else if (isLoading) {
              <div class="status-card loading-state">
                <span class="inline-spinner" aria-hidden="true"></span>
              </div>
            } @else if (visibleModalDisplayRows.length === 0) {
              <div class="status-card empty-results">{{ 'CLIENT_SELECT.EMPTY.NO_RESULTS' | translate }}</div>
            } @else {
              <div class="results-grid">
                <div class="results-scroll-shell" (scroll)="onResultsScroll($event)">
                  <table class="results-table">
                    <thead>
                      <tr class="results-header">
                        @for (column of modalColumns; track column) {
                          <th scope="col">{{ getColumnLabel(column) }}</th>
                        }
                      </tr>
                    </thead>
                    <tbody>
                      @for (row of visibleModalDisplayRows; track row.id) {
                        <tr
                          class="result-row"
                          tabindex="0"
                          (click)="selectRecord(row.record)"
                          (keydown.enter)="selectRecord(row.record)"
                          (keydown.space)="$event.preventDefault(); selectRecord(row.record)">
                          @for (cell of row.cells; track $index) {
                            <td>{{ cell }}</td>
                          }
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>

                @if (isLoadingMore) {
                  <div class="load-more-status">
                    <span class="inline-spinner" aria-hidden="true"></span>
                    <span>{{ 'CLIENT_SELECT.STATUS.LOADING_MORE' | translate }}</span>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>
  <ng-template #fieldComponent></ng-template>
</div>